class PageContainer {
    constructor() {
        this.init();
    }
    init() {
        console.log('UNTUCKit : Container : PageContainer : init', this);
    }
}
export default PageContainer;
